import {
  Button,
  Checkbox,
  Link,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Dialog,
  Grid,
  Paper,
  Typography,
  FormControl,
  IconButton,
  AppBar,
  Toolbar
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Loaded, isLoaded, Empty} from 'Core/models/Async';
import {EnrollmentFileRejectsGetEmail} from 'Enrollment/models/EnrollmentFileRejectsGetEmail';
import {
  changeEnrollmentFileRejectsEmail,
  sendEnrollmentFileRejectsEmail,
  auditEnrollmentFileRejectsAttachmentDownload,
} from 'Enrollment/ducks/enrollmentFileProcessingReject';
import HtmlParser from 'react-html-parser';
import React, {useEffect, useState, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router';
import {ReducerState} from 'rootReducer';
import './EnrollmentFileRejectsEmail.sass';
import CloseIcon from '@material-ui/icons/Close';
import Loading from 'Shared/components/Loading';
import {InvalidEmail, matchEmail, ValidEmail, UnvalidatedEmail} from 'Core/models/Email';
import {createSnackbar} from 'Core/ducks/snackbar';
import {EnrollmentFileRejectDetailApplication} from 'Enrollment/models/EnrollmentFileRejectDetailApplication';
import {useParams} from 'react-router-dom';

type EnrollmentFileRejectsEmailProps = {
  onClose: () => void;
  isResend: boolean;
  emailId?: string;
  groupId?: string;
};

const EnrollmentFileRejectsEmail = (props: EnrollmentFileRejectsEmailProps) => {
  const {isResend, emailId, groupId} = props;
  const {enrollmentFileRejectsEmail, enrollmentFileRejectDetail} = useSelector(
    (state: ReducerState) => state.enrollmentFileProcessingReject
  );
  const {applicationSource: applicationSource} = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [toEmail, setToEmail] = useState<string[]>([]);
  const [ccEmail, setCCEmail] = useState<string[]>([]);
  const [bodyContent, setBodyContent] = useState<string>('');
  const [isRecipient, setIsRecipient] = useState(false);
  const [isCCRecipient, setIsCCRecipient] = useState(false);
  const [addEmail, setAddEmail] = useState('');
  const [addCCEmail, setAddCCEmail] = useState('');
  const [toEmailOptions, setToEmailOptions] = useState<string[]>([]);
  const [ccEmailOptions, setCCEmailOptions] = useState<string[]>([]);
  const [emailData, setEmailData] = useState<Loaded<EnrollmentFileRejectsGetEmail>>({
    key: 'Loaded',
    Data: {
      isBodyHtml: false,
    },
  });

  const setContentHtml = useCallback((content: string) => {
    if (content) {
      content = content.replace('[AccountNumber]', emailData.Data.accountNumber || '');
      content = content.replace('[Comments]', emailData.Data.comments || '');
    }

    const contentHtml = document.createElement('html');

    contentHtml.innerHTML = content;

    const contentHeadElement = contentHtml.querySelector<HTMLHeadElement>('head')!;
    const contentHeadStyleElement = contentHeadElement.querySelector<HTMLStyleElement>('style')!;
    const contentBodyElement = contentHtml.querySelector<HTMLBodyElement>('body')!;

    let documentStyleElement = document.querySelector<HTMLStyleElement>('#template-style');

    if (documentStyleElement === null) documentStyleElement = document.createElement('style');

    const documentHeadElement = document.querySelector<HTMLHeadElement>('head')!;

    documentStyleElement.id = 'template-style';

    documentStyleElement.innerHTML = contentHeadStyleElement.innerText;

    documentHeadElement.appendChild(documentStyleElement);

    contentHtml.removeChild(contentHeadElement);

    content = contentBodyElement.innerHTML;

    return content;
  }, [emailData.Data.comments, emailData.Data.accountNumber]);

  const useStyles = makeStyles(theme => ({
    loader: {
      height: '75vh',
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    formControl: {
      width: '100%',
    },
  }));

  const classes = useStyles();

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const {onClose} = props;

  useEffect(() => {
    history.listen(() => {
      onClose();
    });
  }, [history, onClose]);

  useEffect(() => {
    const emailTemplateData = enrollmentFileRejectsEmail as Loaded<EnrollmentFileRejectsGetEmail>;
    if (emailTemplateData.Data && !isRecipient) {
      const toEmailAddress = emailTemplateData.Data.to!.filter(d => d.emailNotification).map(d => d.email);
      const toEmailAddressOptions = emailTemplateData.Data.to!.map(d => d.email);
      setEmailData(emailTemplateData);
      setToEmail(toEmailAddress as string[]);
      setToEmailOptions(toEmailAddressOptions as string[]);
      setBodyContent(setContentHtml(emailTemplateData.Data.body!));
    }
  }, [setContentHtml, emailData.Data.comments, enrollmentFileRejectsEmail, isRecipient]);

  useEffect(() => {
    const emailTemplateData = enrollmentFileRejectsEmail as Loaded<EnrollmentFileRejectsGetEmail>;
    if (emailTemplateData.Data && !isCCRecipient ) {
      const ccEmailAddress = emailTemplateData.Data.cc!.filter(d => d.emailNotification).map(d => d.email);
      const ccEmailAddressOptions = emailTemplateData.Data.cc!.map(d => d.email);
      setEmailData(emailTemplateData);
      setCCEmail(ccEmailAddress as string[]);
      setCCEmailOptions(ccEmailAddressOptions as string[]);
      setBodyContent(setContentHtml(emailTemplateData.Data.body!));
    }
  }, [setContentHtml, emailData.Data.comments, enrollmentFileRejectsEmail, isCCRecipient]);

  useEffect(() => {
    return () => {
      dispatch(changeEnrollmentFileRejectsEmail(new Empty()));
    };
  }, [dispatch]);

  const handleFieldsOnChange = (
    event: React.ChangeEvent<{name?: string; value: unknown}>,
    emailData: Loaded<EnrollmentFileRejectsGetEmail>
  ) => {
    if (emailData) {
      if (event.target.name === 'emailTo') {
        const toEmail = event.target.value as string[];
        emailData.Data.to!.map(n => (n.emailNotification = toEmail.includes(n.email!)));
        setToEmail(toEmail);
      }
      else if (event.target.name === 'emailCC') {
        const ccEmail = event.target.value as string[];
        emailData.Data.cc!.map(n => (n.emailNotification = ccEmail.includes(n.email!)));
        setCCEmail(ccEmail);
        }

      dispatch(changeEnrollmentFileRejectsEmail(emailData));
    }
  };

  const downloadAttachment = (emailData: Loaded<EnrollmentFileRejectsGetEmail>) => {
    dispatch(auditEnrollmentFileRejectsAttachmentDownload(
      {
        caseRequestID: emailData!.Data!.caseRequestID!,
        attachment: emailData!.Data!.attachment!,
        attachmentName: emailData!.Data!.attachmentName,
      }
    ));
  };

  const addRecipient = (emailData: Loaded<EnrollmentFileRejectsGetEmail>) => {
    const onValidEmail = () => {
      const existingEmail = emailData.Data.to!.find(to => to.email === addEmail);

      if (!existingEmail) {
        emailData.Data.to!.push({
          email: addEmail,
          emailNotification: true,
        });

        dispatch(createSnackbar(`${addEmail} was added to the list of recipients.`));
      }
      setAddEmail('');
      setEmailData(emailData);
      dispatch(changeEnrollmentFileRejectsEmail(emailData));
      setIsRecipient(false);
    };
    const onInvalidEmail = (email: InvalidEmail | UnvalidatedEmail) => {
      dispatch(createSnackbar(email.validationError));
    };

    const email = ValidEmail.create(addEmail);

    matchEmail(email, {
      InvalidEmail: onInvalidEmail,
      UnvalidatedEmail: onInvalidEmail,
      ValidEmail: onValidEmail,
    });
  };

  const addCCRecipient = (emailData: Loaded<EnrollmentFileRejectsGetEmail>) => {
    const onValidEmail = () => {
      const existingEmail = emailData.Data.cc!.find(cc => cc.email === addCCEmail);

      if (!existingEmail) {
        emailData.Data.cc!.push({
          email: addCCEmail,
          emailNotification: true,
        });

        dispatch(createSnackbar(`${addCCEmail} was added to the list of recipients.`));
      }
      setAddCCEmail('');
      setEmailData(emailData);
      dispatch(changeEnrollmentFileRejectsEmail(emailData));
      setIsCCRecipient(false);
    };
    const onInvalidEmail = (email: InvalidEmail | UnvalidatedEmail) => {
      dispatch(createSnackbar(email.validationError));
    };

    const email = ValidEmail.create(addCCEmail);

    matchEmail(email, {
      InvalidEmail: onInvalidEmail,
      UnvalidatedEmail: onInvalidEmail,
      ValidEmail: onValidEmail,
    });
  }; 

  const sendEmail = (emailData: Loaded<EnrollmentFileRejectsGetEmail>, isResend: boolean) => {
    let enrollmentFileRejectsDetail = enrollmentFileRejectDetail as Loaded<EnrollmentFileRejectDetailApplication>;
    dispatch(
      sendEnrollmentFileRejectsEmail(
        {
          caseRequestId: emailData.Data.caseRequestID,
          to: emailData.Data.to!.filter(n => n.emailNotification === true).map(d => d.email) as string[],
          cc: emailData.Data.cc!.filter(n => n.emailNotification === true).map(d => d.email) as string[],
          subject: emailData.Data.subject,
          accountNumber: emailData.Data.accountNumber,
          comments: emailData.Data.comments,
          rejectApplications: !isResend
            ? enrollmentFileRejectsDetail.Data.applications!.filter(d => d.isIncludedInEmail === true)
            : [],
          fileId: !isResend ? enrollmentFileRejectsDetail.Data.fileId! : emailData.Data.fileId, 
          applicationSource: !isResend ?  enrollmentFileRejectsDetail.Data.applicationSource! : applicationSource!, 
          emailId,
          groupId,
          isResend: props.isResend,
        },
        applicationSource!,
        () => {
          props.onClose();
        }
      )
    );
  };

  const renderRecipient = () => {
    if (!isRecipient) {
      return (
        <div className="full-width">
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="recipients-label" variant="outlined" htmlFor="to-email-outlined">
              To
            </InputLabel>

            <Select
              id="to-email-outlined"
              labelId="recipients-label"
              name="emailTo"
              multiple
              value={toEmail}
              onChange={e => handleFieldsOnChange(e, emailData)}
              renderValue={selected => (selected as string[]).join(', ')}
              MenuProps={MenuProps}
              fullWidth
            >
              {toEmailOptions.length === 0 ? (
                <MenuItem key={'to-placeholder'} value={''}>
                  <ListItemText primary={'No recipients have been added.'} />
                </MenuItem>
              ) : (
                toEmailOptions.map(email => (
                  <MenuItem key={`to-${email}`} value={email}>
                    <Checkbox checked={toEmail.indexOf(email ? email : '') > -1} />
                    <ListItemText primary={email} />
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
          <div className="grid__col grid__col--3of12--medium">
            <Button color="primary" onClick={() => setIsRecipient(true)}>
              Add Recipient
            </Button>
          </div>
        </div>
      );
    } else {
      return (
        <div className="full-width">
          <TextField
            id="addRecipient-email-outlined"
            name="emailAddRecipient"
            label="To"
            value={addEmail || ''}
            onChange={e => setAddEmail(e.target.value)}
            margin="normal"
            variant="outlined"
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Button color="primary" onClick={() => addRecipient(emailData)}>
            Add To Email List
          </Button>
          <Button color="primary" onClick={() => setIsRecipient(false)}>
            Cancel
          </Button>
        </div>
      );
    }
  };

  const renderCCRecipient = () => {
    if (!isCCRecipient) {
      return (
        <div className="full-width">
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="cc-recipients-label" variant="outlined" htmlFor="cc-email-outlined">
              CC
            </InputLabel>

            <Select
              id="cc-email-outlined"
              labelId="recipients-label"
              name="emailCC"
              multiple
              value={ccEmail}
              onChange={e => handleFieldsOnChange(e, emailData)}
              renderValue={selected => (selected as string[]).join(', ')}
              MenuProps={MenuProps}
              fullWidth
            >
              {ccEmailOptions.length === 0 ? (
                <MenuItem key={'cc-placeholder'} value={''}>
                  <ListItemText primary={'No CC recipients have been added.'} />
                </MenuItem>
              ) : (
                ccEmailOptions.map(email => (
                  <MenuItem key={`cc-${email}`} value={email}>
                    <Checkbox checked={ccEmail.indexOf(email ? email : '') > -1} />
                    <ListItemText primary={email} />
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
          <div className="grid__col grid__col--3of12--medium">
            <Button color="primary" onClick={() => setIsCCRecipient(true)}>
              Add CC Recipient
            </Button>
          </div>
        </div>
      );
    } else {
      return (
        <div className="full-width">
          <TextField
            id="addCCRecipient-email-outlined"
            name="emailAddCCRecipient"
            label="CC"
            value={addCCEmail || ''}
            onChange={e => setAddCCEmail(e.target.value)}
            margin="normal"
            variant="outlined"
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Button color="primary" onClick={() => addCCRecipient(emailData)}>
            Add CC Email List
          </Button>
          <Button color="primary" onClick={() => setIsCCRecipient(false)}>
            Cancel
          </Button>
        </div>
      );
    }
  };

  const modifyContent = () => setBodyContent(setContentHtml(emailData.Data.body!));

  return (
    <div className="genelco-applications__dialog">
      <Dialog
        open
        disableBackdropClick
        fullScreen
      >
        <AppBar className="genelco-applications__dialog-header">
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6">Error Email</Typography>
            <Button
              color="primary"
              onClick={() =>
                emailData.Data.to!.length === 0
                  ? dispatch(createSnackbar('No recipients have been added.'))
                  : sendEmail(emailData, isResend)
              }
              variant="contained"
              startIcon={<i className="fas fa-x fa-paper-plane"></i>}
              className="floatRight"
            >
              Send
            </Button>
          </Toolbar>
        </AppBar>
        <div className="modal__body">
          {isLoaded(enrollmentFileRejectsEmail) ? (
            <Grid container spacing={1}>
              <Grid item xs={12} md={6} lg={4}>
                <form className={classes.form} autoComplete="off" noValidate>
                  <div className="box">
                    <TextField
                      id="account-email"
                      name="emailAccount"
                      label="Account Number"
                      value={emailData.Data.accountNumber || ''}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={e => {
                        emailData.Data.accountNumber = e.target.value;
                        handleFieldsOnChange(e, emailData);
                      }}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                      disabled={isResend}
                    />
                    {renderRecipient()}
                    {renderCCRecipient()}
                    <TextField
                      id="subject-email-outlined"
                      name="emailSubject"
                      label="Subject"
                      multiline
                      rows="3"
                      value={emailData.Data.subject || ''}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={e => {
                        emailData.Data.subject = e.target.value;
                        handleFieldsOnChange(e, emailData);
                      }}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                    />
                    <TextField
                      id="outlined-multiline-flexible"
                      name="emailMessage"
                      label="Additional Message"
                      multiline
                      rows="5"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      rowsMax="5"
                      onChange={e => {
                        emailData.Data.comments = e.target.value;
                        handleFieldsOnChange(e, emailData);
                      }}
                      value={emailData.Data.comments || ''}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                    />
                    <Button
                      onClick={() => modifyContent()}
                      color="default"
                      variant="outlined"
                      size="small"
                      className="floatRight"
                    >
                      Preview
                    </Button>
                  </div>
                </form>
              </Grid>
              <Grid item xs={12} md={6} lg={8} className="emailGrid">
                <Typography variant="overline" className="emailTypography">
                  {'Email Preview'}
                </Typography>
                <Paper square>
                  <div className="enrollment-file-rejects-email">
                    <Typography className="emailTypography" variant="caption">
                      {'From: '}
                      {emailData.Data.from}
                    </Typography>
                    <Typography className="emailTypography" variant="caption">
                      {'To: '}
                      {(toEmail as string[]).join(', ')}
                    </Typography>
                    <Typography className="emailTypography" variant="caption">
                      {'Cc: '}
                      {(ccEmail as string[]).join(', ')}
                    </Typography>
                    <Typography className="emailTypography" variant="caption">
                      {'Subject: '}
                      {`${isResend ? 'RE: ' : ''}${emailData.Data.subject}`}
                    </Typography>
                    <Link onClick={() => downloadAttachment(emailData)} variant="caption" component="button">
                      <i className="fas fa-x fa-paperclip"> </i> Attachment
                    </Link>
                    <hr />
                    <div className="htmlPreview">{HtmlParser(bodyContent)}</div>
                  </div>
                </Paper>
              </Grid>
            </Grid>
          ) : (
            <div className={classes.loader}>
              <Loading />
            </div>
          )}
        </div>
      </Dialog>
    </div>
    
  );
};

export default EnrollmentFileRejectsEmail;
